import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=5db8b2b2&scoped=true&lang=pug"
import script from "./file-upload.js?vue&type=script&lang=js&external"
export * from "./file-upload.js?vue&type=script&lang=js&external"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=5db8b2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db8b2b2",
  null
  
)

export default component.exports